
function startAccount(){
	$('.row').each(function(){
		var h1=$(this).children(':eq(0)').height();
		var h2=$(this).children(':eq(1)').height();
		if(h1>h2)h2=h1;
		$(this).children('.accountBox').children('.t').children('.b').css('min-height',h2);
	});
	eArchiveHint();
}

function deleteWatchedProducts(text){
	if($('input.zaznacz:checked').length>0){
			var products=[];
			$('input.zaznacz:checked').each(function(){
				products.push($(this).val());
			});
			bottomBar.removeFromClipboard(products);
	}else{
		var opt={autoDimensions:true,type:''};
		$.fancybox('<div class="w350"><div class="tcenter f13 p10">'+text+'</div><div class="buttonA mT10"><a class="ok" href="javascript:void(0);" onclick="$.fancybox.close()"></a><div class="clear"></div></div></div>',opt);
	}
}
function deleteLastVisitedProducts() {
	if($('input.zaznacz:checked').length>0){
			var products=[];
			console.log(products)
			$('input.zaznacz:checked').each(function(){
				products.push($(this).val());
			});
			bottomBar.removeFromLastVisited(products);
	}else{
		var opt={autoDimensions:true,type:''};
		$.fancybox('<div class="w350"><div class="tcenter f13 p10">'+text+'</div><div class="buttonA mT10"><a class="ok" href="javascript:void(0);" onclick="$.fancybox.close()"></a><div class="clear"></div></div></div>',opt);
	}
}
function notifyFriendCheck(text){
	if($('input.zaznacz:checked').length>0){
		$('#notifyFriendF')[0].click();
	}else{
		var opt={autoDimensions:true};
		$.fancybox('<div class="w350"><div class="tcenter f13 p10">'+text+'</div><div class="buttonA mT10"><a class="ok" href="javascript:void(0);" onclick="$.fancybox.close()"></a><div class="clear"></div></div></div>',opt);
	}
}

function lastVisitedStart(info) {
	$('#menu-clipboard-sub').show().parent().addClass('has-children');
	$('#clipboard_last_visited').parent().addClass('active');
	$("#watchedForm .usunZaznaczone").on("click", function(){
		deleteLastVisitedProducts(info);
	});
}

function watchedStart(info){
	$('#menu-clipboard-sub').show().parent().addClass('has-children');
	$('#clipboard_watched').parent().addClass('active');
	$("#watchedForm .usunZaznaczone").on("click", function(){
		deleteWatchedProducts(info);
	});

	$('.input.zaznacz').attr('checked',false);
	var location=document.location.search;
	var count=0;
	if(location.length>5){
		location=location.substr(1).split('&');
		$(location).each(function(i,n){
			var element=$('#zaznacz'+n.substr(5));
			if(element.length){
				element.attr('checked',true);
				count++;
			}
		})
	}
	if(count>0){
		$('.polecZnajomemu')[0].click();
	}
}
function orderStart(k){
	cartStart(cartType);
	$('#menu-orders-sub').show().parent().addClass('has-children');
}

function ordersStart(pageName){
	$('#your-orders, #menu-orders-sub').show().parent().addClass('has-children');
	selectActiveMenuItem(pageName);

	$('#your-orders-A').addClass('bold');
	$('.fancy').fancybox({
		width: 550,
		height:420,
		type:'iframe'
	});
}
function selectActiveMenuItem(pageName) {
	switch (pageName) {
		case 'complaint-history':
			$('#complaints_history').parent().addClass('active');
			break;
		case 'subscription-payments':
			$('#subscription_payments').parent().addClass('active');
			break;
		case 'b':
		case 'e':
			$('#orders_actual').parent().addClass('active');
			break;
		case 'esd':
			$('#orders_esd').parent().addClass('active');
			break;
		case 'h':
			$('#orders_archival').parent().addClass('active');
			break;
		case 'p':
			$('#payment_forms').parent().addClass('active');
			break;
	}
}

function agreementsStart(){
	$('#menu-account-sub').show().parent().addClass('has-children');
	$('#account_agreements').parent().addClass('active');
}
function invoiceStart(){
	$('#menu-account-sub').show().parent().addClass('has-children');
	$('#account_invoice').parent().addClass('active');
	if (document.location.hash.indexOf('#edit-') == 0) {
		let hash = document.location.hash.substr(6) / 1;
		$('a.edytuj' + hash).click();
	}
}
function deliveryAddressStart(){
	$('#menu-account-sub').show().parent().addClass('has-children');
	$('#account_delivery').parent().addClass('active');
	if (document.location.hash.indexOf('#edit-') == 0) {
		let hash = document.location.hash.substr(6) / 1;
		$('a.edytuj' + hash).click();
	}
}

function passwordStart(){
	$('#menu-account-sub').show().parent().addClass('has-children');
	$('#account_password').parent().addClass('active');

	passwordStartCommon();
}

$(document).ready(function(){

	$('#menu-clipboard').click(function(){
		$(this).parent().toggleClass('has-children');
		$('#menu-clipboard-sub').toggle();
	});
	$('#menu-account').click(function(){
		$(this).parent().toggleClass('has-children');
		$('#menu-account-sub').toggle();
	});
	$('#menu-utterance').click(function(){
		$(this).parent().toggleClass('has-children');
		$('#menu-utterance-sub').toggle();
	});
	$('#menu-orders').click(function(){
		$(this).parent().toggleClass('has-children');
		$('#menu-orders-sub').toggle();
	});
	$('#menu-partner-program').on('click',function(){
		UA.interaction('Program Partnerski','Kliknięcie','KME');
	});
	$('#katalog-prod li ul li a').hover(function(){$(this).parent().addClass('hoverLi');},function(){$(this).parent().removeClass('hoverLi');});
});

function cancelOrderOk(orderNumber, guestLogged){

	if (showLoginViewIfLogout(true)) {
		return;
	}
	UA.cancelOrder(orderNumber);
	UA.pageview('/akcje/konto-klienta/zamowienia/anuluj-zamowienie');
	loadingStart();

	var reasonId=$('input[name=reason]:checked').val() || '';
	$.ajax({
		url: guestLogged ? '/guest-order-cancel.ltr' : '/customer-order-cancel.ltr',
		type:'POST',
		cache:false,
		data: {
			reasonId: reasonId,
			reasonOtherDetails: $('#reasonOtherMessage input').val(),
			orderNumber:orderNumber
		},
		success: function(html){
			app.alert(html, function() {
 				loadingStart();
 				location.reload();
 			});
		},
		error: function(html){
			loadingStop();
			app.alert('Wystąpił błąd anulowania Zamówienia, prosimy spróbować później');
		}
	});
}

function validateReason(){
	var reasonId=$('input[name=reason]:checked').val();
	if(reasonId){
		$('#reasonError').hide();
	}else{
		$('#reasonError').show();
	}
}

function cancelOrder(formId, orderNumber, guestLogged) {

	if (showLoginViewIfLogout()) {
		return;
	}

	var option={
		autoDimensions:true,
		onComplete:function(){
			$('#fancybox-content .errorBox').errorBox();
			$('#fancybox-content input[name="reason"]').click(function(){
				otherCancelReason($(this).val());
			});
			checkbox('#fancybox-content .orderCancel .left');
			$.fancybox.resize();
		},
		onError:function(){return false}
	};
	$.fancybox({
		href: guestLogged ? '/guest-order-cancel-reason.ltr?orderNumber='+orderNumber : '/customer-order-cancel-reason.ltr?orderNumber='+orderNumber
	},option);
}

function otherCancelReason(value){
	setTimeout(function(){validateReason();},200);
	if(value==$('#otherReasonId').val()){
		$('#reasonOtherMessage').show().find('input').val('');
	}else{
		$('#reasonOtherMessage').hide().find('input').val('');
	}
}

function declinationOfZnak(x){
	if (x == 1) {
		return x + ' znak';
	} else if ((x % 10 > 1 && x % 10 < 5) && !(x % 100 > 11 && x % 100 < 15)) {
		return x + ' znaki';
	} else {
		return x + ' znaków';
	}
}
function opinionTab(state){
	if(state!=''){
		$('#opinion-menu li').removeClass('active');
		$('#opinion-menu li.'+state).addClass('active');
		$('#customer-content .tab').hide();
		$('#customer-content .tab'+state).show();

		www.account.getTab(state);
	}else{
		opinionTab('opinion');
	}
}
function opinionQuestionAnswerStart(){
	$('#opinion-menu a').click(function(){
		$.History.go($(this).attr('href').substr(1));
		return false;
	});
	$('#menu-utterance-sub a').removeAttr('onclick');
	$.History.bind(function(state){
		opinionTab(state);
	});
	if(document.location.hash=='')opinionTab('');
}

www.account={
	waitForCheckNick:false,
	changeNick:function(element){
		var container = $(element).parents('.change-nick');
		var	that = this;
		var	nick = container.find('.nick');
		var	nickStatus=container.find('.nick-status');
		var $editNickForm = container.find('form[name=edit_nick]');
		$editNickForm.validate({
			rules:{
				"nick":{
					required:true,
					minlength:3,
					maxlength:64,
					userNick:true
				}
			},
			messages:{
				"nick":{
					required:"Wypełnij pole"
				}
			}
		});
		if(!$editNickForm.valid()){
			nickStatus.html('');
			return false;
		}

		if(!this.waitForCheckNick){
			this.waitForCheckNick=true;
			nickStatus.addClass('loading');
			nick.attr('disabled',true);
			$.ajax({
				url:'/customer-unique-nick.ltr',
				type:'POST',
				data:{
					nick:nick.val(),
					ACTION:'CHECK_SAVE',
					account:true
				},
				complete:function(){
					that.waitForCheckNick=false;
					nick.removeAttr('disabled');
				},
				success:function(html){
					nickStatus.removeClass('loading');
                    nickStatus.html(html);
				},
				error:function(){
					fancyOk('Wystąpił błąd komunikacji, prosimy spróbować później');
				}
			});
		}
	},
	getTab:function(state){
		$('#menu-utterance-sub').show().parent().addClass('has-children');
		$('#menu-utterance-sub li').removeClass('active');

		if(state == 'question'){
			this.question.getQuestions();
			$('#utterance_questions').parent().addClass('active');
		}else if(state == 'answer'){
			this.answer.getAnswers();
			$('#utterance_answers').parent().addClass('active');
		}else if(state == 'opinion-to-add'){
			$('#utterance_opinions_to_add').parent().addClass('active');
		}else{
			$('#utterance_opinions').parent().addClass('active');
		}
	},
	paginationPosition:function(){
		var margin;
		var paginator = $('.paginator:visible');
		var paginatorBox = paginator.parent();
		margin = (paginatorBox.width()-paginator.width())/2;
		paginator.css('margin-left',margin+'px');
	},
	question:{
		minCharacters:3,
		maxCharacters:400,
		minText:"Podaj minimum 3 znaki",
		maxText:"Podaj maksymalnie 400 znaków",
		getQuestions:function(page, sortType){
			var that = this;
			page = typeof page !== 'undefined' ? page : 1;
			sortType = typeof $('#questions-order').val() !== 'undefined' ? $('#questions-order').val() : 'DATE_ADDED_DESC';
			loadingStart();
			showLoginViewIfLogout(fancybox);
			var data = {
				'pageNr':page,
				sort:sortType
			};
			$.ajax({
				url:'/customer-product-questions.ltr',
				data: data,
				success: function(html){
					$('#customer-questions').html(html);
					checkbox('.qa-edit');
					www.account.paginationPosition();
					$('#customer-questions .showTooltip > a').tooltip({
						extraClass: "QiA",
						track: true,
						showUrl:false,
						top: -35,
						left: 30,
						bodyHandler:function(){
							return $(this).next().html() || '';
						}
					});
					loadingStop();
				},
				error: function(){
					loadingStop();
				}
			});
		},
		changePage:function(page){
			this.getQuestions(page);
		},
		confirmRemoveQuestion:function(token){
			var that = this;
			loadingStart();
			showLoginViewIfLogout(fancybox);
			$.ajax({
				url:'/customer-product-question-edit.ltr',
				data: {
					'F_ACTION':'DELETE',
					'token':token
				},
				type:'POST',
				success:function(html){
					$.fancybox(html,{
						autoDimensions:	true,
						onComplete:function(){
							$('#deleteForm .nie').click(function(){
								$.fancybox.close();
							});
							$('#deleteForm .tak').click(function(){
								that.removeQuestion(token);
							});
						}
					});
				}
			});
		},
		removeQuestion:function(token){
			var that = this;
			loadingStart();
			showLoginViewIfLogout(fancybox);
			$.ajax({
				url:'/customer-product-question-edit.ltr',
				data: {
					'F_ACTION':'CONFIRM_DELETE',
					'token':token
				},
				type:'POST',
				success: function(returnMessage){
					if(returnMessage.actionNotAllowedMessage){
						fancyOk(returnMessage.actionNotAllowedMessage);
					}else{
						var currentPage = $('#question-paging').attr('data-currentPage');
						that.getQuestions(currentPage);

					}
				}
			});
		},
		loadQuestionForm:function(token){
			var that = this;
			showLoginViewIfLogout(fancybox);
			$.ajax({
				url:'/customer-product-question-edit.ltr',
				data:{
					'token':token
				},
				success: function(html){
					$.fancybox(html,{
						autoDimensions:	true,
						padding:0
					});
					that.loadQuestionFormSuccess(token);
				}
			});
		},
		loadQuestionFormSuccess:function(token){
			var that = this;
			var form = $('#question-edit-form');
			checkbox('#question-edit-form');
			form.find('label a').click(function(e){
				e.stopPropagation();
			});
			form.find('.submitButton').click(function(event){
				event.preventDefault();
				form.submit();
			});
			form.find('.errorBox').errorBox();
			form.validate({
				rules:{
					content:{
						required:true,
						minlength: that.minCharacters,
						maxlength: that.maxCharacters
					}
				},
				messages:{
					content:{
						required:'Podaj treść pytania',
						minlength: that.minText,
						maxlength: that.maxText
					}
				},
				submitHandler: function(form) {
					that.saveQuestion(token);
				}
			});
			form.find('input:checkbox').click(function(){
				var that=$(this);
				setTimeout(function(){
					if(that.hasClass('error'))form.validate().element(that);
				},100);
			});
			$(form.find('textarea').not('.hasEditor')).autosize();
			form.find('textarea.hasEditor').show().wysiwyg();
		},
		saveQuestion:function(token){
			var that = this,
			form = $('#question-edit-form');
			showLoginViewIfLogout(fancybox);
			form.ajaxSubmit({
				url:'/customer-product-question-edit.ltr',
				data:{
					'F_ACTION':'SAVE',
					'token':token
				},
				target:'#fancybox-content > div',
				success:function(html){
					if(html.indexOf('form') > 0){
						that.loadQuestionFormSuccess(token);
					}else{
						var currentPage = $('#question-list').attr('data-currentPage');
						that.getQuestions(currentPage);
						$.fancybox.close();
					}
				}
			});
		},
		cancelNotifications:function(e){
			e.preventDefault();
			loadingStart();
			showLoginViewIfLogout(fancybox);
			$.ajax({
				url:'/customer-product-question-edit.ltr',
				data: {
					'F_ACTION':'ALL_NOTIFICATIONS_OFF'
				},
				type:'POST',
				success: function(returnMessage){
					if(returnMessage.actionNotAllowedMessage){
						fancyOk(returnMessage.actionNotAllowedMessage);
					}else{
						$('#question-list').find('input[type="checkbox"]').attr('checked', false);
						loadingStop();
					}
				},
			});
		},
		toggleProductOwnerNotification:function(e){
			e.preventDefault();
			loadingStart();
			showLoginViewIfLogout(fancybox);
			$.ajax({
				url:'/customer-product-question-edit.ltr',
				data: {
					'F_ACTION':'TOGGLE_PRODUCT_OWNER_NOTIFICATION'
				},
				type:'POST',
				success: function(returnMessage){
					if(returnMessage.actionNotAllowedMessage){
						fancyOk(returnMessage.actionNotAllowedMessage);
					}else{
						var json = returnMessage;
						$('#productOwnerNotificationText').html(
							json.productOwnerNotificationStatus ? "Włącz" : "Wyłącz"
						);
						app.logEvent({
							id:(json.productOwnerNotificationStatus)?'productOwnerNotificationOff':'productOwnerNotificationOn',
							f03:getUserId()
						});
						loadingStop();
					}
				}
			});
		},
		changeNotification:function(token){
			loadingStart();
			showLoginViewIfLogout(fancybox);
			$.ajax({
				url:'/customer-product-question-edit.ltr',
				data: {
					'F_ACTION':'TOGGLE_NOTIFICATION',
					'token':token
				},
				type:'POST',
				success: function(returnMessage){
					if(returnMessage.actionNotAllowedMessage){
						fancyOk(returnMessage.actionNotAllowedMessage);
					}else{
						loadingStop();
					}
				},
			});
		}
	},
	answer:{
		minCharacters:3,
		maxCharacters:400,
		minText:"Podaj minimum 3 znaki",
		maxText:"Podaj maksymalnie 400 znaków",
		getAnswers:function(page, sortType){
			var that = this;
			page = typeof page !== 'undefined' ? page : 1;
			sortType = typeof $('#answers-order').val() !== 'undefined' ? $('#answers-order').val() : 'DATE_ADDED_DESC';
			loadingStart();
			showLoginViewIfLogout(fancybox);
			var data = {
				'pageNr':page,
				sort:sortType
			};
			$.ajax({
				url:'/customer-product-answers.ltr',
				data: data,
				success: function(html){
					$('#customer-answers').html(html);
					checkbox('.qa-edit');
					www.account.paginationPosition();
					$('#customer-answers .showTooltip > a').tooltip({
						extraClass: "QiA",
						track: true,
						showUrl:false,
						top: -35,
						left: 30,
						bodyHandler:function(){
							return $(this).next().html() || '';
						}
					});
					loadingStop();
				}
			});
		},
		changePage:function(page){
			this.getAnswers(page);
		},
		confirmRemoveAnswer:function(token){
			var that = this;
			loadingStart();
			showLoginViewIfLogout(fancybox);
			$.ajax({
				url:'/customer-product-answer-edit.ltr',
				data: {
					'F_ACTION':'DELETE',
					'token':token
				},
				type:'POST',
				success:function(html){
					$.fancybox(html,{
						autoDimensions:	true,
						onComplete:function(){
							$('#deleteForm .nie').click(function(){
								$.fancybox.close();
							});
							$('#deleteForm .tak').click(function(){
								that.removeAnswer(token);
							});
						}
					});
				}
			});
		},
		removeAnswer:function(token){
			var that = this;
			loadingStart();
			showLoginViewIfLogout(fancybox);
			$.ajax({
				url:'/customer-product-answer-edit.ltr',
				data: {
					'F_ACTION':'CONFIRM_DELETE',
					'token':token
				},
				type:'POST',
				success: function(returnMessage){
					if(returnMessage.actionNotAllowedMessage){
						fancyOk(returnMessage.actionNotAllowedMessage);
					}else{
						var currentPage = $('#answer-paging').attr('data-currentPage');
						that.getAnswers(currentPage);

					}
				},
			});
		},
		toggleProductQuestions:function(){
			var trigger = $('#toggle-productQuestions');
			var table = $('#productQuestions');
			table.slideToggle(function(){
				if(table.is(':visible')){
					trigger.text('zwiń').addClass('open');
				}else{
					trigger.text('rozwiń').removeClass('open');
				}
			});
		},
		loadAnswerForm:function(token){
			var that = this;
			showLoginViewIfLogout(fancybox);
			$.ajax({
				url:'/customer-product-answer-edit.ltr',
				data:{
					'token':token
				},
				success: function(html){
					$.fancybox(html,{
						autoDimensions:	true,
						padding:0
					});
					that.loadAnswerFormSuccess(token);
				}
			});
		},
		loadAnswerFormSuccess:function(token){

			var that = this;
			var form = $('#answer-edit-form');
			checkbox('#answer-edit-form');
			form.find('label a').click(function(e){
				e.stopPropagation();
			});
			form.find('.submitButton').click(function(event){
				event.preventDefault();
				form.submit();
			});
			form.find('.errorBox').errorBox();
			form.validate({
				rules:{
					content:{
						required:true,
						minlength: that.minCharacters,
						maxlength: that.maxCharacters
					}
				},
				messages:{
					content:{
						required:'Podaj treść odpowiedzi',
						minlength: that.minText,
						maxlength: that.maxText
					}
				},
				submitHandler: function(form) {
					that.saveAnswer(token);
				}
			});
			form.find('input:checkbox').click(function(){
				var that=$(this);
				setTimeout(function(){
					if(that.hasClass('error'))form.validate().element(that);
				},100);
			});
			$(form.find('textarea').not('.hasEditor')).autosize();
			form.find('textarea.hasEditor').show().wysiwyg();
		},
		saveAnswer:function(token){
			var that = this,
			form = $('#answer-edit-form');
			showLoginViewIfLogout(fancybox);
			form.ajaxSubmit({
				url:'/customer-product-answer-edit.ltr',
				data:{
					'F_ACTION':'SAVE',
					'token':token
				},
				target:'#fancybox-content > div',
				success:function(html){
					if(html.indexOf('form') > 0){
						that.loadAnswerFormSuccess(token);
					}else{
						var currentPage = $('#answer-paging').attr('data-currentPage');
						that.getAnswers(currentPage);
						$.fancybox.close();
					}
				}
			});
		},
		cancelNotifications:function(e){
			e.preventDefault();
			loadingStart();
			showLoginViewIfLogout(fancybox);
			$.ajax({
				url:'/customer-product-answer-edit.ltr',
				data: {
					'F_ACTION':'ALL_NOTIFICATIONS_OFF'
				},
				type:'POST',
				success: function(returnMessage){
					if(returnMessage.actionNotAllowedMessage){
						fancyOk(returnMessage.actionNotAllowedMessage);
					}else{
						$('#answer-list').find('input[type="checkbox"]').attr('checked', false);
						loadingStop();
					}
				}
			});
		},
		changeNotification:function(token){
			loadingStart();
			showLoginViewIfLogout(fancybox);
			$.ajax({
				url:'/customer-product-answer-edit.ltr',
				data: {
					'F_ACTION':'TOGGLE_NOTIFICATION',
					'token':token
				},
				type:'POST',
				success: function(returnMessage){
					if(returnMessage.actionNotAllowedMessage){
						fancyOk(returnMessage.actionNotAllowedMessage);
					}else{
						loadingStop();
					}
				}
			});
		}
	},
	opinion:{
		loadOpinionForm: function(opinionId) {
			var that = this;
			$.ajax({
				url:'/customer-opinion-edit.ltr',
				data:{
					'id':opinionId
				},
				success: function(html){
					if(html.indexOf('form') > -1){
						$.fancybox(html,{
							autoDimensions:	true,
							padding: 0,
							hideOnOverlayClick:false,
							target: '#fancybox-content > div',
							onClosed:function(){
								if($('.paging-active.paging-number').length) {
									load('added', $('.paging-active.paging-number').text()*1);
								} else {
									load();
								}
							}
						});
						that.loadOpinionFormSuccess(opinionId);
					} else {
						fancyOk(html);
					}
				}
			});
		},
		loadOpinionFormSuccess: function(opinionId) {
			var that = this;
			var form = $('#opinion-edit-form');
			var timeToEdit = form.find('#opinion-remaining-edit-seconds').val()*1;
			var titleMaxLength = form.find('#customer-opinion-edit-title').attr('maxlength');
			var contentMinLength = form.find('#opinion-content-min-characters').val();
			var contentMaxLength = form.find('#customer-opinion-edit-content').attr('maxlength');

			form.validate({
				rules:{
					title:{
						required:true,
						minlength: 2,
						maxlength: titleMaxLength
					},
					content:{
						required:true,
						minlength: contentMinLength,
						maxlength: contentMaxLength
					}
				},
				messages:{
					title:{
						required:'Podaj tytuł opinii',
						minlength: `Podaj minimum ${declinationOfZnak(2)}`,
						maxlength: `Podaj maksymalnie ${declinationOfZnak(titleMaxLength)}`
					},
					content:{
						required:'Podaj treść opinii',
						minlength: `Podaj minimum ${declinationOfZnak(contentMinLength)}`,
						maxlength: `Podaj maksymalnie ${declinationOfZnak(contentMaxLength)}`
					}
				},
				submitHandler: function() {
					form.find('.response-message').html('');
					that.saveOpinion(opinionId);
				}
			});

			form.find('#customer-opinion-edit-title').on('change keyup',function() {
				$(this).siblings('.error').remove();
				form.find('.response-message').html('');
			})
			form.find('#customer-opinion-edit-content').on('change keyup',function() {
				$(this).siblings('.error').remove();
				form.find('.response-message').html('');
			})

			// timer
			let timer = 0;
			if(timeToEdit > 0){
				let minutes = Math.floor(timeToEdit / 60);
				let seconds = timeToEdit - (minutes * 60);
				const $opinionEditTimer = form.find('#opinion-edit-timer');
				$opinionEditTimer.text('(Pozostały czas na edycję: ' + minutes + 'm ' + (seconds < 10 ? '0' : '') + seconds + 's)');
				timer = setInterval(function(){
					timeToEdit--;
					if(timeToEdit <= 0){
						clearInterval(timer);
						form.find('.js-opinion-submit').attr('disabled', true);
						if(!form.hasClass('loading') || form.find('.response-message p').length === 0){
							form.find('.response-message').html('<p class="error">Czas na edytowanie opinii minął</p>');
						}
					}
					minutes = Math.floor(timeToEdit / 60);
					seconds = timeToEdit - (minutes * 60);
					$opinionEditTimer.text('(Pozostały czas na edycję: ' + minutes + 'm ' + (seconds < 10 ? '0' : '') + seconds + 's)');
				}, 1000);
			}

			// star votes
			const $starsForVoting = $('.js-attribute-grade a', form);
			$('#stars-for-voting .grade-item').each(function(){
				var input=$(this).find('input');
				setActiveStar(input.val(),input.attr('id').substr(5));
			});
			function setActiveStar(grade,id){
				grade=Math.max(grade,0);
				$('#stars'+id+' a').removeClass('active');
				$('#stars'+id+' a:lt('+(grade)+')').addClass('active');
			}
			$starsForVoting.hover(function(){
				var rel=$(this).data('value').split('|');
				setActiveStar(rel[0],rel[1]);
			},function(){
				var rel=$(this).data('value').split('|');
				setActiveStar($('#grade'+rel[1]).val()/1,rel[1]);
			}).click(function(){
				var rel=$(this).data('value').split('|');
				$('#grade'+rel[1]).val(rel[0]);
				setActiveStar($('#grade' + rel[1]).val() / 1, rel[1]);
			});

		},
		saveOpinion:function(opinionId){
			var that = this,
				form = $('#opinion-edit-form');
			form.addClass('loading');
			form.ajaxSubmit({
				url:'/customer-opinion-edit.ltr',
				data:{
					'F_ACTION':'SAVE',
					'id':opinionId
				},
				success:function(resultHtml){
					form.removeClass('loading');
					if(resultHtml.indexOf('form') > -1){
						const $formContent = $(resultHtml).html();
						const errors = $(resultHtml).find('.validate-error, .errorText');
						form.html($formContent);
						if (errors.length){
							that.loadOpinionFormSuccess(opinionId);
							form.find('.response-message').html('<p class="error">Zmiany nie zostały zapisane, ponieważ formularz zawiera błędy</p>');
						} else {
							form.find('.response-message').html('<p class="success">Zmiany zostały zapisane</p>');
							setTimeout(function(){
								$.fancybox.close();
							}, 500);
						}
					} else {
						fancyOk(resultHtml);
					}
				}
			});
		}
	}
}


// funkcje usuwania kart i bankow z preferowanych form płatności


var orderComplaint = (function() {

	function makeShopOrderReclamation(shopOrderId) {
		const requestData = {
			url: '/customer-reclamation-request.ltr',
			payload: { shopOrderId }
		};
		fetchToken(requestData)
			.then(data => fillAndSubmitComplaintForm(data))
			.catch(handleError);
	}

	function makeShopOrderReturn(shopOrderId) {
		const requestData = {
			url: '/customer-return-request.ltr',
			payload: { shopOrderId }
		};
		fetchToken(requestData)
			.then(data => fillAndSubmitComplaintForm( data))
			.catch(handleError);
	}

	function fetchToken({ url, payload }) {
		return $.ajax({
			url,
			data: payload,
			dataType: "json",
			contentType: "application/json"
		});
	}

	function fillAndSubmitComplaintForm(data) {
		const { url, token } = data;
		let $orderComplaintForm = $('<form />').attr({
			action: url,
			method: 'post'
		});
		let $tokenInput = $('<input />').attr({
			name: 'token',
			type: 'hidden',
			value: token
		});
		$orderComplaintForm.append($tokenInput);
		$(document.body).append($orderComplaintForm);
		$orderComplaintForm.submit();
	}

	function handleError() {
		fancyOk("Wystąpił problem podczas przetwarzania żądania. Spróbuj jeszcze raz.");
	}

	return {
		makeShopOrderReclamation,
		makeShopOrderReturn
	};
})();

var orderComplaintLoader = (function() {

	function showComplaintDetails(complaintId) {
		
		if (!isFrontUserLogged()) {
			loadingStart();
			document.location.reload();
			return;
		}
		
		loadingStart();
		$.ajax({
			url: '/customer-order-complaint-details.ltr',
			data: { complaintId },
			success: function (responseHtml) {
				$.fancybox(responseHtml, {
					height: 'auto',
					width: 800,
					onComplete: () => {
						$('html').addClass('print-modal');
					},
					onClosed: () => {
						$('html').removeClass('print-modal');
					}
				});
			},
			error: function(){
				fancyOk("Wystąpił problem podczas pobierania szczegółów zgłoszenia. Spróbuj jeszcze raz.");
			},
			complete: function() {
				loadingStop();
			}
		});
	}

	function loadShopOrderComplaints(shopOrderId) {
		$.ajax({
			url: '/customer-order-complaints.ltr',
			data: { shopOrderId }
		})
			.then(fillComplaintList)
			.fail(handleError);
	}

	function fillComplaintList(responseHtml) {
		$('#complaints').html(responseHtml)
	}

	function handleError() {
		fancyOk("Wystąpił problem podczas pobierania listy reklamacji i zwrotów. Odśwież stronę aby spróbować ponownie.");
	}

	return {
		loadShopOrderComplaints,
		showComplaintDetails
	};
})();

//  Zakładka Twoje Opinie
function loadingOpinion() {
	if(this.href.indexOf('#opinion-to-add') > -1) {
		load('add');
	} else {
		load();
	}
}

function load(type = "added", pageNumber = 1) {
	var url = '/customer-added-opinions-list.ltr';
	var data = {
		pageSize: 10,
		pageNumber
	}
	if (type == "add") {
		url = '/customer-opinions-to-add-list.ltr';
	}
	loadingStart();
	showLoginViewIfLogout(fancybox);

	$.ajax({
		url,
		type: 'get',
		data,
		success: function(res){
			loadingStop();
			$('#customer-opinions').html(res);
			if(type == "add") {
				$('#your-opinion-title').text('Opinie oczekujące na dodanie:');
				$('#your-opinion-link').text('Zobacz dodane opinie').attr('href', '#added-opinion');
				if($('#customer-opinions .question-noData').length){
					$('#customer-opinions .question-noData').text('Brak towarów oczekujących na opinię.');
				}
			}
			$('.js-change-page').click(function() {load(type, $(this).data('to'))});
			$('.js-opinion-fancy').click(jsOpinionFancy);
		},
		error: function(err) {
			console.log(err);
			loadingStop();
			fancyOk("Wystąpił błąd ładowania opinii. Prosimy spróbować później.");
		}
	});
}

function jsOpinionFancy() {
	let id = $(this).data('id'),
		href='/customer-opinion-preview.ltr';
	$.fancybox({
		href:href+'?id='+id
	},{
		autoDimensions: true,
		padding: 10,
		onComplete:function(){
			$('.js-toggle-content').hide();
		}
	});
}
